import pgwyClient from "@/api/pgwyClient";

const Authentication = {
  state: {
    statusResponse: null,
    officerResponse: null
  },
  mutations: {
    setState(state, {statusResponse, officerResponse}) {
      state.statusResponse = statusResponse;
      state.officerResponse = officerResponse;
    }
  },
  actions: {
    async login({ commit }) {
      commit("setState", {});
      const statusResponse = await pgwyClient.login();
      const officerResponse = await pgwyClient.getOfficerDetails();
      commit("setState", {statusResponse, officerResponse});
    },
    async logout({ commit }) {
      commit("setState", {});
      await pgwyClient.logout();
    },
    checkAuthStatus({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.statusResponse) {
          resolve(state.statusResponse);
          return;
        }
        pgwyClient.getStatus().then((statusResponse) => {
          if (statusResponse.data.status === "loggedin") {
            pgwyClient.getOfficerDetails().then((officerResponse) => {
              commit("setState", {statusResponse, officerResponse});
              resolve(statusResponse);
            }).catch(reject);
          } else {
            commit("setState", {statusResponse});
            resolve(statusResponse);
          }
        }).catch(reject);
      });
    },
  },
  getters: {
    getIsAuthenticated(state) {
      return state.statusResponse?.data?.status === "loggedin";
    },
    getRoles(state) {
      return state.officerResponse?.data?.roles || [];
    },
    getOfficerDetails(state) {
      return state.officerResponse?.data;
    }
  },
};

export default Authentication;
